module.exports = __webpack_public_path__ + "img/H2M7_new.a6045a40.jpg";